// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__39baX","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1AHEM"};